import axios from 'axios';
import {
  TRANSITION_ACCEPT_ASSIGNED_GIG,
  TRANSITION_DECLINE_ASSIGNED_GIG,
  TRANSITION_DECLINE_ASSIGNED_GIG_BUSINESS,
} from '../../util/transaction';
import { apiBaseUrl } from '../../util/api';

// ================ Action types ================ //
export const TRANSITION_ASSIGNED_BY_BUSINESS = 'transition/assigned-by-business';

export const STATUS_PENDING = 'pending';
export const STATUS_ACCEPTED = 'accepted';
export const STATUS_DECLINED = 'declined';

export const FETCH_STATUS_REQUEST = 'app/BusinessDashboard/FETCH_STATUS_REQUEST';
export const FETCH_STATUS_SUCCESS = 'app/BusinessDashboard/FETCH_STATUS_SUCCESS';
export const FETCH_STATUS_ERROR = 'app/BusinessDashboard/FETCH_STATUS_ERROR';

export const REMOVE_WORKER_REQUEST = 'app/BusinessDashboard/REMOVE_WORKER_REQUEST';
export const REMOVE_WORKER_SUCCESS = 'app/BusinessDashboard/REMOVE_WORKER_SUCCESS';
export const REMOVE_WORKER_ERROR = 'app/BusinessDashboard/REMOVE_WORKER_ERROR';

// ================ Reducer ================ //

const initialState = {
  fetchStatusInProgress: false,
  workerStatus: {},
  fetchStatusError: null,
  removeWorkerInProgress: false,
  removeWorkerSuccess: false,
  removeWorkerError: null,
  currentTx: {},
};

export default function WorkerCardPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case REMOVE_WORKER_REQUEST:
      return {
        ...state,
        removeWorkerInProgress: payload,
      };
    case REMOVE_WORKER_SUCCESS: {
      return {
        ...state,
        removeWorkerInProgress: false,
        removeWorkerSuccess: true,
      };
    }
    case REMOVE_WORKER_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, removeWorkerInProgress: false, removeWorkerError: payload };

    case FETCH_STATUS_REQUEST:
      return {
        ...state,
        fetchStatusInProgress: true,
        fetchStatusError: null,
      };
    case FETCH_STATUS_SUCCESS: {
      return {
        ...state,
        fetchStatusInProgress: false,
        workerStatus: payload.status,
        currentTx: payload.currentTx,
        fetchStatusError: null,
      };
    }
    case FETCH_STATUS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchStatusInProgress: false, fetchStatusError: payload };

    default:
      return state;
  }
}
// ================ Action creators ================ //

const fetchStatusRequest = () => ({ type: FETCH_STATUS_REQUEST });
const fetchStatusSuccess = res => ({
  type: FETCH_STATUS_SUCCESS,
  payload: res,
});
const fetchStatusError = e => ({
  type: FETCH_STATUS_ERROR,
  error: true,
  payload: e,
});

const removeWorkerRequest = payload => ({ type: REMOVE_WORKER_REQUEST, payload });
const removeWorkerSuccess = response => ({
  type: REMOVE_WORKER_SUCCESS,
  payload: response,
});
const removeWorkerError = e => ({
  type: REMOVE_WORKER_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //
export const removeWorker = params => async (dispatch, getState, sdk) => {
  try {
    const { txId, workerId, listingId, assigendWorkers } = params;
    dispatch(removeWorkerRequest(workerId));
    const isValidTxId = txId !== '0000';
    if (isValidTxId && txId) {
      await sdk.transactions.transition(
        { id: txId, transition: TRANSITION_DECLINE_ASSIGNED_GIG_BUSINESS, params: {} },
        { expand: true }
      );
    }
    const url = `${apiBaseUrl()}/api/user/removeAssignedGigById`;
    await axios.post(url, params);
    if (listingId && assigendWorkers) {
      await sdk.ownListings.update({ id: listingId, privateData: { assigendWorkers } });
    }
    dispatch(removeWorkerSuccess());
  } catch (error) {
    dispatch(removeWorkerError(error));
  }
};
export const fetchWorkerStatus = ({ workerId, listingId }) => async (dispatch, getState, sdk) => {
  try {
    dispatch(fetchStatusRequest());
    let currObj;
    const url = `${apiBaseUrl()}/api/user/getAssignedDataByWorkerIdAndListingId`;
    const data = { listingId, workerId };
    const { data: dbRespData } = await axios.post(url, data);

    if (dbRespData?.length === 1) {
      currObj = dbRespData[0];
    } else {
      currObj = null;
    }
    if (!currObj) {
      return;
    }
    const { txLastTransition } = currObj || {};
    const status =
      txLastTransition === TRANSITION_ASSIGNED_BY_BUSINESS
        ? STATUS_PENDING
        : txLastTransition === TRANSITION_DECLINE_ASSIGNED_GIG
        ? STATUS_DECLINED
        : txLastTransition === TRANSITION_ACCEPT_ASSIGNED_GIG
        ? STATUS_ACCEPTED
        : null;

    const currentStatus = getState().PendingAcceptanceWorkerCardPage.workerStatus;
    const currentStateTx = getState().PendingAcceptanceWorkerCardPage.currentTx;

    const updateStatus = {
      ...currentStatus,
      [`${workerId}+${listingId}`]: { listingId, status: status },
    };
    const updateTx = {
      ...currentStateTx,
      [`${workerId}+${listingId}`]: { listingId, currentTx: currObj },
    };
    return dispatch(fetchStatusSuccess({ status: updateStatus, currentTx: updateTx }));
  } catch (error) {
    dispatch(fetchStatusError(error));
  }
};
